import React from "react";
import { clBasic } from "./general";
import file from "./img/file.png";

export default function ListaAdjuntos({ adjuntos, ind, setRefresh, setTrash }) {
  return (
    <div>
      {adjuntos.length !== 0 ? (
        adjuntos.map((f, i) => {
          let Sadjunto = {
            position: "absolute",
            top: (i * 2 + 6).toString() + "px",
            left: (i * 4).toString() + "px",
            clipPath: "polygon",
          };
          return (
            <img id={"AA" + f} src={file} alt="??" height="25px" width="25px" style={Sadjunto} key={i} title={f.nombre} draggable="false" />
          );
        })
      ) : (
          <i className="material-icons icono32" style={SnoAdj}>
            attach_file
          </i>
        )}
    </div>
  );
}

const SnoAdj = {
  position: "absolute",
  top: "10px",
  left: "0px",
  color: clBasic
};
